import { useTranslation } from 'react-i18next';

const WhySection = () => {
  const { t } = useTranslation();

  const stats = [
    {
      value: t('why.stat1_value'),
      text: t('why.stat1_text')
    },
    {
      value: t('why.stat2_value'),
      text: t('why.stat2_text')
    },
    {
      value: t('why.stat3_value'),
      text: t('why.stat3_text')
    }
  ];

  return (
    <section id="why" className="bg-white py-16 sm:py-10">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
          {stats.map((stat, index) => (
            <div key={index} className="rounded-2xl border p-6 text-center chip">
              <div className="text-4xl font-extrabold text-slate-900">{stat.value}</div>
              <p className="text-sm text-slate-600 mt-2">{stat.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhySection;
